/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import styles from "./Origin.module.scss";
import OriginBanner from "ui/feature/origin/OriginBanner";

const Origin: React.FC = () => {

    return (
        <div className={styles.container}>
            <OriginBanner/>
            <video
                loop={true}
                className={styles.video}
                autoPlay={true}
                playsInline={true}
                muted={true}
                src={"origin.mp4"}/>
        </div>
    );
}

export default Origin